<!--component html goes here -->
<!--component html goes here -->
  <!-- Hero Start -->
<app-header></app-header>
  <!-- <section *ngIf="mainForm" class="bg-half-170 bg-light d-table w-100" style="background: url('assets/images/EventImag.jpg') center center;" id="home">
    <div class="bg-overlay"></div>
    <div class="container " >
            <div class="col-lg-12 text-center">
                <div class="pages-heading">
                    <h4 class="title text-white title-dark mb-0">Events in {{modelObject.countryNameEn}}</h4>
                </div>
            </div>
        <div class="position-breadcrumb" *ngIf="mainForm">
            <nav aria-label="breadcrumb" class="d-inline-block">
                <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                    <li class="breadcrumb-item"><a routerLink="">Blimp</a></li>
                    <li class="breadcrumb-item"><a>Events</a></li>
                </ul>
            </nav>
        </div>
    </div>
  </section> -->
  <!--end section-->
  <!-- Hero End -->
  
  <!-- Shape Start -->
  <!-- <div class="position-relative">
    <div class="shape overflow-hidden text-color-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
  </div> -->
  <!--Shape End-->
  
  <!-- Blog STart -->
  <section  *ngIf="mainForm" class="bg-half" id="home" >
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="section-title text-center mb-4 pb-2">
                    <h4 ><span class="text-primary">Events world</span></h4>
                    <p class="text-muted para-desc mx-auto mb-0">All <span
                            class="text-primary fw-bold">events in {{modelObject.countryNameEn}}</span> that may interest you</p>
                </div>
            </div>
            <!--end col-->
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 mb-4 pb-2" *ngFor="let data of rows">
                <div class="breadcrumb-item card blog rounded border-0 shadow overflow-hidden" style="width: 319px; height: 306px;"  (click)="EventDetails(data.id)">
                    <div class="position-relative" >
                        <img src="{{data.images}}" class="card-img-top" alt="..." width="319px" height="175px">
                        <div class="overlay rounded-top bg-dark"></div>
                    </div>
                    <div class="card-body content">
                        <h5><a href="javascript:void(0)" class="card-title title text-dark">{{data.titleEn}}</a></h5>
                        <div class="post-meta d-flex justify-content-between mt-3">
                            <ul class="list-unstyled mb-0">
                                        <li class="list-inline-item me-2 mb-0">
                                             <ngb-rating [max]="5" [(rate)]="data.averageStar" [readonly]="true" style="font-size: 25px;">
                                             </ngb-rating></li>
                                <!-- <li class="list-inline-item"><a href="javascript:void(0)" class="text-muted comments"><i
                                            class="uil uil-comment me-1"></i>{{data.message}}</a></li> -->
                            </ul>
                            <ul class="list-unstyled mb-0">
                                <li class="list-inline-item me-2 mb-0">
                                    <a  (click)="EventDetails(data.id)" class="text-muted readmore">Read More <i
                                        class="uil uil-angle-right-b align-middle"></i></a>
                                </li>
                               
                            </ul>
                      
                        </div>
                    </div>
                    <div class="author">
                        <small class="text-light user d-block"><i class="uil uil-user"></i> {{data.titleEn}}</small>
                        <small class="text-light date"><i class="uil uil-calendar-alt"></i> {{data.date|date:'dd/MM/yyyy hh:MM'}}</small>
                    </div>
                </div>
            </div>
            <!--end col-->
  
            <!-- PAGINATION START -->
            <div class="col-12">
                <ul class="pagination justify-content-center mb-0">
                    <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Previous">Prev</a>
                    </li>
                    <li class="page-item active"><a class="page-link" href="javascript:void(0)">1</a></li>
                    <li class="page-item"><a class="page-link" href="javascript:void(0)">2</a></li>
                    <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
                    <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Next">Next</a></li>
                </ul>
            </div>
            <!--end col-->
            <!-- PAGINATION END -->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
  </section>
  <!--end section-->
  <!-- Blog End -->
  
  <!-- Back to top -->
  <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
  </a>
  <!-- Back to top -->
   